import React, { FunctionComponent, useEffect } from 'react';
import { toast } from '@shopee/chatbot-ui';
import { BaseUploadCard, FileType, UploadStatus } from '@shopee/chatbot-ui/lib/components/BaseUpload';
import { useUpload } from '@/utils/UploadManager';
import { getTrans } from '@/utils/instantLoaded/tools';
import reporter from '@/utils/report';

export const showUploadErrorToast = () => toast.error(getTrans('probing_form_submit_failed'));

export interface FileUploadProps {
  file: File;
  onSuccess: (url: string) => void;
  onRemove: () => void;
  onPreview: () => void;
  showRemoveIcon?: boolean;
}

export const FileUploadWrapper: FunctionComponent<FileUploadProps> = (props) => {
  const { error, finish, fileUrl } = useUpload(props.file);

  useEffect(() => {
    reporter.apiBatchReport({ type: 'count', value: { label: 'probing_form_upload_file_total' }});
    if (finish) {
      reporter.apiBatchReport({ type: 'count', value: { label: 'probing_form_upload_file_success' }});
      props.onSuccess(fileUrl);
    }

    if (error) {
      showUploadErrorToast();
      props.onRemove();

      reporter.apiLog(
        `【Probing Form Upload】file upload failed, errormsg:${JSON.stringify(error)}`,
        { level: 'error' },
      );
    }
  }, [finish, error]);

  const getStatus = () => {
    if (finish) {
      return UploadStatus.Success;
    } else {
      return UploadStatus.Loading;
    }
  };

  return (
    <BaseUploadCard
      file={{ type: FileType.File, name: props.file.name, originFile: props.file, status: getStatus() }}
      onRemove={props.onRemove}
      onPreview={props.onPreview}
      showRemoveIcon={props.showRemoveIcon}
    />
  );
};
